/**
 * Side-effect module: registers every built-in puzzle type. Import once from the app entry.
 * Components are lazy so a player opening a text puzzle never downloads the SVG grid.
 */
import { akariModule } from "./akari/module";
import { boggleModule } from "./boggle/module";
import { bridgesModule } from "./bridges/module";
import { chessMateModule } from "./chess-mate/module";
import { compositeModule } from "./composite/module";
import { countdownModule } from "./countdown/module";
import { crosswordModule } from "./crossword/module";
import { cryptogramModule } from "./cryptogram/module";
import { fifteenPuzzleModule } from "./fifteen-puzzle/module";
import { gridSudokuModule } from "./grid-sudoku/module";
import { hiddenArticleModule } from "./hidden-article/module";
import { lightsOutModule } from "./lights-out/module";
import { litsModule } from "./lits/module";
import { mastermindModule } from "./mastermind/module";
import { masyuModule } from "./masyu/module";
import { minesweeperModule } from "./minesweeper/module";
import { norinoriModule } from "./norinori/module";
import { nurikabeModule } from "./nurikabe/module";
import { pegSolitaireModule } from "./peg-solitaire/module";
import { picrossModule } from "./picross/module";
import { registerPuzzleType } from "./registry";
import { rushHourModule } from "./rush-hour/module";
import { scrabbleModule } from "./scrabble/module";
import { semanticWordModule } from "./semantic-word/module";
import { slitherlinkModule } from "./slitherlink/module";
import { sokobanModule } from "./sokoban/module";
import { spellingBeeModule } from "./spelling-bee/module";
import { starBattleModule } from "./star-battle/module";
import { staticPromptModule } from "./static-prompt/module";
import { tentsModule } from "./tents/module";
import { wordGroupsModule } from "./word-groups/module";
import { wordLadderModule } from "./word-ladder/module";
import { wordleModule } from "./wordle/module";

registerPuzzleType(gridSudokuModule);
registerPuzzleType(staticPromptModule);
registerPuzzleType(compositeModule);
registerPuzzleType(picrossModule);
registerPuzzleType(chessMateModule);
registerPuzzleType(crosswordModule);
registerPuzzleType(sokobanModule);
registerPuzzleType(scrabbleModule);
registerPuzzleType(semanticWordModule);
registerPuzzleType(hiddenArticleModule);
registerPuzzleType(slitherlinkModule);
registerPuzzleType(masyuModule);
registerPuzzleType(bridgesModule);
registerPuzzleType(nurikabeModule);
registerPuzzleType(litsModule);
registerPuzzleType(norinoriModule);
registerPuzzleType(starBattleModule);
registerPuzzleType(tentsModule);
registerPuzzleType(akariModule);
registerPuzzleType(minesweeperModule);
registerPuzzleType(wordleModule);
registerPuzzleType(mastermindModule);
registerPuzzleType(spellingBeeModule);
registerPuzzleType(boggleModule);
registerPuzzleType(wordLadderModule);
registerPuzzleType(wordGroupsModule);
registerPuzzleType(cryptogramModule);
registerPuzzleType(rushHourModule);
registerPuzzleType(fifteenPuzzleModule);
registerPuzzleType(lightsOutModule);
registerPuzzleType(pegSolitaireModule);
registerPuzzleType(countdownModule);

export { getPuzzleType, listPuzzleTypes, registerPuzzleType } from "./registry";
